// Pledges list page (CHG-1248 / ITER-3371).
//
// Thin per the v10 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates pledgeListConfig from
// pledge.entity-hint.yaml (CHG-1228) without touching this file.
//
// Spec: specs/tier-05-experience/pledges-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { pledgeListConfig } from "../generated/screens/pledge-list";

export function Pledges() {
  return <ListPage config={pledgeListConfig} />;
}
